module.exports = {"query":"?query","prev":null}


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/query/loaders/queryloader.js?query!
 ** module id = 2
 ** module chunks = 0
 **/